import { createDecorator } from '../../instantiation/common/instantiation.js';
const IPolicyService = ( createDecorator('policy'));
export { IPolicyService };
